"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H6"));

var _Filter = _interopRequireDefault(require("./Filter"));

var _FilterButton = _interopRequireDefault(require("./FilterButton"));

var _filterUtils = require("AudienceTargetingUIComponents/utils/filterUtils");

var FilterGroup =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterGroup, _PureComponent);
  (0, _createClass2.default)(FilterGroup, null, [{
    key: "propTypes",
    get: function get() {
      return {
        addHideGroup: _react.PropTypes.func,
        addFilter: _react.PropTypes.func.isRequired,
        filterOptions: _react.PropTypes.object.isRequired,
        filters: _react.PropTypes.instanceOf(_immutable.List).isRequired,
        groupId: _react.PropTypes.string.isRequired,
        hasHideGroup: _react.PropTypes.bool,
        hasScope: _react.PropTypes.bool.isRequired,
        isShow: _react.PropTypes.bool.isRequired,
        labelConfig: _react.PropTypes.object,
        onChange: _react.PropTypes.func,
        onBlur: _react.PropTypes.func,
        removeEnabled: _react.PropTypes.bool.isRequired,
        removeFilter: _react.PropTypes.func.isRequired,
        upgradeConfig: _react.PropTypes.object.isRequired,
        updateFilter: _react.PropTypes.func.isRequired
      };
    }
  }]);

  function FilterGroup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FilterGroup);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterGroup).call(this, props));
    _this.handleAddFilter = _this.handleAddFilter.bind((0, _assertThisInitialized2.default)(_this));
    _this.addHideGroup = _this.addHideGroup.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FilterGroup, [{
    key: "addHideGroup",
    value: function addHideGroup() {
      var groupId = this.props.groupId;
      this.props.addHideGroup(groupId);
    }
  }, {
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "AudienceTargeting." + suffix;
    } // TODO: to make it reusable, move this out of components

  }, {
    key: "getDisabledOperators",
    value: function getDisabledOperators() {
      var filters = this.props.filters;
      var disabledOperators = [];

      if (filters.size > 1) {
        disabledOperators.push('ALL');
      }

      return disabledOperators;
    } // TODO: to make it reusable, move this out of components

  }, {
    key: "getOptions",
    value: function getOptions(filter) {
      var filterOptions = this.props.filterOptions;
      var type = filter.get('type');
      var filterOption = filterOptions[type];
      var isNotUrl = type !== 'URL' && type !== 'QUERY_PARAM';
      var filteredOptions = (0, _extends3.default)({}, filterOptions);

      if (!isNotUrl) {
        return (0, _filterUtils.filterByGroup)(filterOptions, filterOption.group);
      } else if (isNotUrl) {
        delete filteredOptions['URL'];
        delete filteredOptions['QUERY_PARAM'];
        return filteredOptions;
      } else {
        return filterOptions;
      }
    }
  }, {
    key: "filterGroup",
    value: function filterGroup(group) {
      var filterOptions = this.props.filterOptions;
      var options = Object.keys(filterOptions).map(function (i) {
        return (0, _extends3.default)({
          id: i
        }, filterOptions[i]);
      }).filter(function (i) {
        return i.group === group;
      }).reduce(function (acc, i) {
        return (0, _extends3.default)({}, acc, (0, _defineProperty2.default)({}, i.id, i));
      }, {});
      return {
        group: group,
        options: options
      };
    }
  }, {
    key: "displayAddFilter",
    value: function displayAddFilter() {
      var _this$props = this.props,
          filterOptions = _this$props.filterOptions,
          filters = _this$props.filters;
      var type = filters.getIn(['values', 0, 'type']);
      var filter = filterOptions[type] || null;
      return filter ? filter.addOperator : false;
    }
  }, {
    key: "hasFilterAll",
    value: function hasFilterAll() {
      var filters = this.props.filters;
      var allOperator = filters.find(function (filter) {
        return filter.get('operator') === 'ALL';
      });
      return Boolean(allOperator);
    }
  }, {
    key: "addFilterEnabled",
    value: function addFilterEnabled() {
      var _this$props2 = this.props,
          filters = _this$props2.filters,
          isShow = _this$props2.isShow;
      var normalizedFilters = isShow ? filters : (0, _filterUtils.getOrValues)(filters);
      var values = normalizedFilters.getIn([0, 'values']);

      if (normalizedFilters.getIn([0, 'type']) === 'QUERY_PARAM') {
        return !this.hasFilterAll() && Boolean(values.getIn(['value'])) && Boolean(values.getIn(['name'])) || values === false;
      } else {
        return !this.hasFilterAll() && Boolean(values) || values === false;
      }
    }
  }, {
    key: "handleRemoveFilter",
    value: function handleRemoveFilter(index) {
      var _this$props3 = this.props,
          groupId = _this$props3.groupId,
          isShow = _this$props3.isShow,
          removeFilter = _this$props3.removeFilter;
      removeFilter(index, groupId, isShow);
    }
  }, {
    key: "handleAddFilter",
    value: function handleAddFilter() {
      var _this$props4 = this.props,
          addFilter = _this$props4.addFilter,
          filters = _this$props4.filters,
          groupId = _this$props4.groupId,
          isShow = _this$props4.isShow;
      var values = isShow ? filters : (0, _filterUtils.getOrValues)(filters);
      var isURL = /^(URL|QUERY_PARAM)$/.test(values.get(0).get('type'));
      addFilter(groupId, isShow, isURL);
    }
  }, {
    key: "renderFilters",
    value: function renderFilters() {
      var _this2 = this;

      var _this$props5 = this.props,
          filters = _this$props5.filters,
          groupId = _this$props5.groupId,
          hasScope = _this$props5.hasScope,
          isShow = _this$props5.isShow,
          labelConfig = _this$props5.labelConfig,
          onChange = _this$props5.onChange,
          onBlur = _this$props5.onBlur,
          removeEnabled = _this$props5.removeEnabled,
          upgradeConfig = _this$props5.upgradeConfig,
          updateFilter = _this$props5.updateFilter;
      var normalizedFilters = filters;
      if (!isShow) normalizedFilters = filters.getIn([0, 'values']);
      var disabledOperators = this.getDisabledOperators();
      return normalizedFilters.map(function (filter, index) {
        return _react.default.createElement(_Filter.default, {
          key: index,
          filterIndex: index,
          filterOptions: _this2.getOptions(filter),
          filter: filter,
          groupId: groupId,
          hasScope: hasScope,
          labelConfig: labelConfig,
          disabledOperators: disabledOperators,
          isFirst: index === 0,
          isShow: isShow,
          removeEnabled: removeEnabled || !isShow ? true : index > 0,
          onBlur: onBlur,
          onRemove: function onRemove() {
            _this2.handleRemoveFilter(index);

            onChange();
          },
          upgradeConfig: upgradeConfig,
          updateFilter: updateFilter
        });
      });
    }
  }, {
    key: "renderAddButton",
    value: function renderAddButton() {
      var _this3 = this;

      var _this$props6 = this.props,
          filters = _this$props6.filters,
          labelConfig = _this$props6.labelConfig,
          isShow = _this$props6.isShow;
      var tooltipText = this.hasFilterAll() ? 'addDisabled' : 'noValue';
      var isURL = filters.get(0).get('type') === 'URL';
      if (!isURL) tooltipText = 'addDisabledBehaviour';

      var tooltip = labelConfig[tooltipText] || _I18n.default.text(this.getLangKey(tooltipText));

      var label = isShow ? 'addRule' : 'addHideSegment';

      if (this.addFilterEnabled()) {
        return _react.default.createElement(_FilterButton.default, {
          label: label,
          onClick: function onClick() {
            return _this3.handleAddFilter();
          }
        });
      }

      return _react.default.createElement(_UITooltip.default, {
        title: tooltip
      }, _react.default.createElement("span", null, _react.default.createElement(_FilterButton.default, {
        disabled: true,
        label: label,
        onClick: function onClick() {
          return _this3.handleAddFilter();
        }
      })));
    }
  }, {
    key: "renderHideButton",
    value: function renderHideButton() {
      var hasHideGroup = this.props.hasHideGroup;
      if (hasHideGroup || hasHideGroup === undefined) return null;
      return _react.default.createElement(_FilterButton.default, {
        label: "addHideSegment",
        onClick: this.addHideGroup
      });
    }
  }, {
    key: "renderShowGroup",
    value: function renderShowGroup() {
      var _this$props7 = this.props,
          hasHideGroup = _this$props7.hasHideGroup,
          isShow = _this$props7.isShow,
          labelConfig = _this$props7.labelConfig;

      var _ref = labelConfig || {},
          assetName = _ref.assetName;

      var labelText = _I18n.default.text(this.getLangKey("" + (isShow ? 'show' : 'hide'))) + " " + assetName;

      var label = _react.default.createElement(_H.default, {
        className: "group-label"
      }, labelText);

      var hideClass = "" + (!isShow && 'hide-group');
      var groupClasses = "group-container " + (!hasHideGroup && 'group-bottom');
      return _react.default.createElement(_UITabs.default, {
        className: "tabs-container",
        listClassName: hideClass,
        panelClassName: groupClasses + " " + hideClass,
        use: "enclosed"
      }, _react.default.createElement(_UITab.default, {
        className: "group-title " + hideClass,
        title: label
      }, _react.default.createElement("div", null, this.renderFilters(), _react.default.createElement("div", {
        className: "add-button-container"
      }, this.renderAddButton(), this.renderHideButton()))));
    }
  }, {
    key: "render",
    value: function render() {
      var isShow = this.props.isShow;
      var hideContainerClass = isShow ? 'show-container' : 'hide-container';
      return _react.default.createElement("div", {
        className: hideContainerClass
      }, this.renderShowGroup());
    }
  }]);
  return FilterGroup;
}(_react.PureComponent);

exports.default = FilterGroup;
module.exports = exports.default;